/* eslint-disable jsx-a11y/label-has-associated-control */
import { XMarkIcon } from "@heroicons/react/24/solid";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "components/atoms/buttons/Button";
import DateOnlyPickerInput from "components/atoms/forms/datepicker/DateOnlyPickerInput";
import Modal from "components/atoms/modal";
import moment from "moment";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { downloadOnClick } from "utils";
import { get } from "utils/request";
import * as yup from "yup";
import { TOAST_CONFIG } from "../../../../../constants";

export default function ClaimResponseModel({ open, onClose, magnet_id }: any) {
  const [isStartDatePickerModalOpen, setIsStartDatePickerModalOpen] = useState(false);
  const [isEndDatePickerModalOpen, setIsEndDatePickerModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("allResponse");

  const claimResponseFormSchema = yup.object().shape({
    From_date:
      selectedOption === "byDate"
        ? yup.date().max(new Date(), "From Date cannot be in future").required("* Required field")
        : yup.date(),
    To_date:
      selectedOption === "byDate"
        ? yup
            .date()
            .nullable()
            .when("From_date", (start, schema) =>
              start ? schema.min(start, "To Date must be after From Date") : schema,
            )
            .max(new Date(), "From Date cannot be in future")
            .required("* Required field")
        : yup.date(),
  });

  const {
    setValue,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm({
    resolver: yupResolver(claimResponseFormSchema),
    mode: "onChange",
  });

  const handleSetEndDateTime = (value: any) => {
    setValue("To_date", value);
  };
  const handleSetStartDateTime = (value: any) => {
    setValue("From_date", value);
  };

  const handleOptionChange = (option: string) => {
    setSelectedOption(option);
  };

  const downloadClaimResponse = (magnetId: string) => `/api/v1/magnet/${magnetId}/get-claim-form-data/`;

  const handleDownloadClaimForm = (resp: any) => {
    downloadOnClick(URL.createObjectURL(resp.data));
    toast.success("Claim Forms Data successfully received.", TOAST_CONFIG);
    onClose();
  };

  const handleClaimFormError = () => {
    onClose();
    toast.error("Sorry. Your requested data could not be processed right now.", TOAST_CONFIG);
  };

  function handleClaimResponseDownloadFile(data: any) {
    let queryParams = {};
    if (selectedOption !== "allResponse") {
      queryParams = {
        start_date: moment(data.From_date).startOf("day").valueOf().toString(),
        end_date: moment(data.To_date).endOf("day").valueOf().toString(),
      };
    }

    get(downloadClaimResponse(magnet_id), {
      queryParams: {
        ...queryParams,
      },

      processData: handleDownloadClaimForm,
      processError: handleClaimFormError,
      requestConfig: {
        responseType: "blob",
      },
      headers: {
        "Content-Type": "application/octate-stream",
      },
    });
  }

  return (
    <Modal open={open} onClose={onClose} closeOnOutsideClick={false}>
      <div className="relative w-[97vw] max-w-[40rem] rounded-2xl bg-primary px-1 pb-8 pt-2 text-white">
        <button type="button" onClick={onClose} className=" absolute right-5 top-5 z-40 hover:rounded-lg hover:border">
          <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
        </button>
        <div className=" py-4 text-center text-xl font-medium ">Claim Responses</div>
        <div className="flex justify-center gap-10 py-2">
          <div>
            <input
              type="checkbox"
              id="allResponse"
              name="responseType"
              checked={selectedOption === "allResponse"}
              onChange={() => handleOptionChange("allResponse")}
            />
            <label className="pl-3" htmlFor="allResponse">
              All Response
            </label>
          </div>
          <div>
            <input
              type="checkbox"
              id="byDate"
              name="responseType"
              checked={selectedOption === "byDate"}
              onChange={() => handleOptionChange("byDate")}
            />
            <label className="pl-3" htmlFor="byDate">
              By Date
            </label>
          </div>
        </div>
        <div className="flex flex-col gap-3 py-6 ">
          <div className="flex items-center justify-around gap-5">
            <div className="text-xl font-medium">From</div>
            <div className="mt-2 w-2/3">
              <DateOnlyPickerInput
                isDatePickerModalOpen={isStartDatePickerModalOpen}
                setIsDatePickerModalOpen={setIsStartDatePickerModalOpen}
                startDateTime={watch("From_date")}
                error={errors.From_date?.message}
                handleSetDateTimeForMomemto={handleSetStartDateTime}
                id="From_date"
                isDisabled={selectedOption === "allResponse"}
                disableFuture
              />
            </div>
          </div>
          <div className="flex items-center justify-around gap-5">
            <div className="min-w-[62px] text-xl font-medium">To</div>
            <div className="mt-2 w-2/3">
              <DateOnlyPickerInput
                isDatePickerModalOpen={isEndDatePickerModalOpen}
                setIsDatePickerModalOpen={setIsEndDatePickerModalOpen}
                startDateTime={watch("To_date")}
                error={errors.To_date?.message}
                handleSetDateTimeForMomemto={handleSetEndDateTime}
                id="To_date"
                isDisabled={selectedOption === "allResponse"}
                disableFuture
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <Button
            variant="rustPinkSolid"
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            text="DOWNLOAD"
            type="submit"
            onClick={handleSubmit((formData) => handleClaimResponseDownloadFile(formData))}
          />
        </div>
      </div>
    </Modal>
  );
}
